import { useMutation } from '@apollo/client';
import { Button, Modal, ModalFooter, ModalHeader, Stack, useNotifications } from '@sixfold/common-ui';
import React, { useState } from 'react';

import { DeleteCompanyIdentifierMutation, DeleteCompanyIdentifierMutationVariables } from '../../lib/graphql';
import { companyQuery, deleteCompanyIdentifierMutation } from '../graphql';

type Props = {
  trigger: React.ReactElement | string;
  companyIdentifierId: string;
  companyId: string;
};

export const CompanyIdentifierModifyModal = (props: Props) => {
  const notify = useNotifications();
  const [isOpen, setIsOpen] = useState(false);
  const [deleteCompanyIdentifier] = useMutation<
    DeleteCompanyIdentifierMutation,
    DeleteCompanyIdentifierMutationVariables
  >(deleteCompanyIdentifierMutation);

  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleDelete = async () => {
    try {
      await deleteCompanyIdentifier({
        variables: {
          input: {
            companyIdentifierId: props.companyIdentifierId,
          },
        },
        refetchQueries: [
          {
            query: companyQuery,
            variables: {
              company_id: props.companyId,
            },
          },
        ],
      });
      onToggle();
      notify.success({ title: 'Company identifier deleted.' });
    } catch (_error) {
      notify.error({ title: 'Deleting the identifier failed.' });
    }
    onToggle();
  };

  return (
    <Modal trigger={props.trigger} open={isOpen} onToggle={onToggle}>
      <ModalHeader title={'Delete company identifier?'} />
      <ModalFooter>
        <Stack justifyContent="end">
          <Button kind="subtle" onClick={onToggle}>
            Cancel
          </Button>
          <Button onClick={handleDelete} disabled={false} kind="primary">
            Delete
          </Button>
        </Stack>
      </ModalFooter>
    </Modal>
  );
};
